<!--
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-02-22 16:31:35
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-09-16 10:39:24
 * @FilePath: \newsmallmap\src\views\Login.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="content">
    <div class="Loginlogo">
      <!-- <img src="../../src/assets/images/czlogo.png" alt /> -->
      <div class="demoLogo">水电站来水预测气象服务平台</div>
    </div>
    <el-card class="box-card">
      <div class="title">
        <p>统一登陆</p>
      </div>
      <el-divider></el-divider>
      <div class="bodyer">
        <span>账号：</span>
        <el-input
          v-model="username"
          type="text"
          suffix-icon="el-icon-user-solid"
          placeholder="请输入账号"
          style="width: 300px; margin-top: 20px;"
        ></el-input>
        <br />
        <span>密码：</span>
        <el-input
          v-model="password"
          type="password"
          suffix-icon="el-icon-key"
          placeholder="请输入密码"
          style="width: 300px; margin-top: 20px;"
        ></el-input>
      </div>
      <div class="footer" style=" margin-top: 40px;">
        <el-button
          type="primary"
          style="width: 300px; height: 50px; float: right;"
          @click="submit"
        >登录</el-button>
      </div>
      <div class="forget">
        <p style="font-size: 14px;margin-top: 150px;padding-left: 150px; color: #409EFF;">忘记密码？</p>
      </div>
    </el-card>
    <div class="maplogo">
      <img src="../assets/maplogo.png" alt />
    </div>
  </div>
</template>

<script >
import jsCookie from "js-cookie";
export default {
  data() {
    return {
      username: "",
      password: ""
    };
  },
  methods: {
    submit() {
      if (this.username == "outtest") {
        window.location.href =
          "http://120.79.183.250:8081/fzjzout/index.html#/";
      } else {
        console.log(122112);
        let formData = new FormData();

        formData.append(
          "para",
          `{"userName":"${this.username}","password":"${this.password}"}`
        );
        console.log(formData);
        this.$axios({
          method: "post",
          url: `
      http://120.79.183.250:3099/user/login`,
          data: formData
        }).then(res => {
          console.log(res);
          console.log(res.data.code);
          if (res.data.code == 200) {
            jsCookie.set("name", this.username);
            jsCookie.set("areainfo", JSON.stringify(res.data.userInfo));
            console.log(JSON.stringify(res.data.userInfo));
            this.$store.commit("setisLogon",true)
            this.$router.push({
              name: "Watch",
              params: {
                id: this.username,
                areainfo: res.data.userInfo
              }
            });
          } else {
            this.$message({
              message: "账号密码错误",
              type: "warning"
            });
          }
        });
      }

      //   if (
      //     this.username == "root" ||
      //     this.username == "shimian" ||
      //     this.username == "yingjing"
      //   ) {
      //     jsCookie.set("name", this.username);
      //     this.$router.push("/home");
      //   }
      //   if (this.username == "root") {
      //     this.$router.push({
      //       name: "/",
      //       params: {
      //         id: "root"
      //       }
      //     });
      //   } else if (this.username == "shimian") {
      //     this.$router.push({
      //       name: "/",
      //       params: {
      //         id: "shimian"
      //       }
      //     });
      //   } else if (this.username == "yingjing") {
      //     this.$router.push({
      //       name: "/",
      //       params: {
      //         id: "yingjing"
      //       }
      //     });
      //   }
    }
  }
};
</script>

<style scoped>
body {
  padding: 0;
  margin: 0;
}
.content {
  position: fixed;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  background-image: url(../assets/banner.png);
}
.Loginlogo {
  position: absolute;
  left: 10%;
  top: 10vh;
  z-index: 2;
}
.Loginlogo img {
  width: auto;
  max-width: 100%;
}
.maplogo {
  position: absolute;
  left: 45%;
  top: 18vh;
}
.maplogo img {
  width: auto;
  max-width: 100%;
}
.box-card {
  width: 400px;
  height: 500px;
  display: flex;
  justify-content: center;
  position: absolute;
  left: 10%;
  top: 30vh;
  z-index: 3;
}
.box-card p {
  font-weight: 400;
  font-size: 28px;
  margin-left: 35%;
}
.box-card .bodyer .el-input__inner {
  height: 55px !important;
  background-color: white !important;
  color: #000000 !important;
}
.demoLogo {
  font-size: 55px;
  color: white;
  font-weight: 700;
}
/* .el-input__inner {
  background-color: white !important;
  color: #000000 !important;
} */
</style>